import { initializeWebTracking } from '@hqo/web-tracking';
import { setUser as setSentryUser } from '@sentry/react';
import { useEffect } from 'react';
import { useSentryAnalytics } from 'app/shared/hooks/use-sentry-analytics';
import { useWebTrackingAnalytics } from 'app/shared/hooks/use-web-tracking';

export const useAnalytics = (): void => {
  const analytics = useSentryAnalytics();
  const webTrackingData = useWebTrackingAnalytics();

  useEffect(() => {
    /*
     * Sentry identifies a user by a TOP-LEVEL `id`. The `visitor`/`account` payload is Pendo's
     * shape, so passing it straight through left Sentry with no id at all — it fell back to IP
     * address, and "users affected" counted networks rather than people. Hoist the id and keep
     * the rest as context.
     */
    setSentryUser(analytics ? { ...analytics, id: analytics.visitor?.id } : null);
  }, [analytics]);

  useEffect(() => {
    if (webTrackingData?.currentUser && webTrackingData?.buildingUuid) {
      initializeWebTracking(
        webTrackingData?.authToken,
        webTrackingData?.buildingUuid,
        webTrackingData?.appUuid,
        navigator?.userAgent,
        webTrackingData?.clientApiUrl,
      );
    }
  }, [
    webTrackingData?.appUuid,
    webTrackingData?.buildingUuid,
    webTrackingData?.authToken,
    webTrackingData?.clientApiUrl,
    webTrackingData?.currentUser,
  ]);
};
